exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EditUserModal__guests___1hoJP {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin: 0 -12px;\n  width: 245px;\n}\n\n.EditUserModal__multiGuests___2XDPo:not(.EditUserModal__mobile___1qA5F) {\n  width: 538px;\n}\n", ""]);

// exports
exports.locals = {
	"guests": "EditUserModal__guests___1hoJP",
	"multiGuests": "EditUserModal__multiGuests___2XDPo",
	"mobile": "EditUserModal__mobile___1qA5F"
};